// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  userInfo: null,
  accessToken: null,
  abilities: [],
  userPermission: [],
};

// Redux Slice for Logged in user
const loggedInUserInfoSlice = createSlice({
  name: "loggedInUserInfo",
  initialState,
  reducers: {
    setUserInfo(state, { payload }) {
      console.log("####", payload);
      state.userInfo = payload;
    },
    setAccessToken(state, { payload }) {
      state.accessToken = payload;
    },
    removeAccessToken(state) {
      state.accessToken = null;
    },
    setAbilities(state, { payload }) {
      state.abilities = payload;
    },
    setUserPermission(state, { payload }) {
      state.userPermission = payload;
    },
    setUpdatedUserInfo(state, { payload }) {
      state.userInfo = {
        ...state.userInfo,
        name: payload.name,
        designation: payload.designation,
        email: payload.email,
        contact_details: payload.contact_details,
        gender: payload.gender
      }
    }
  },
});

export const loggedInUserInfoSliceActions = loggedInUserInfoSlice.actions;

export default loggedInUserInfoSlice;
